/* eslint-disable @typescript-eslint/no-explicit-any */
import AppLayout from "@/components/app-layout";
import { getUserInfo } from "@/services/userService";
import { Navigate, useLocation } from "react-router-dom";

function ProtectedRoute({children, allowedRoles = [] }: {children: React.ReactNode, allowedRoles?: string[]}) {
    const location = useLocation();
    
    // Helper function to safely get user data
    const getUserData = () => {
        try {
            return getUserInfo();
        } catch (error) {
            console.error("Error parsing user data:", error);
            // Clear invalid data
            sessionStorage.removeItem("user");
            return null;
        }
    };
    
    // Helper function to get user role
    const getUserRole = (user: any) => {
        // Try different possible structures
        return user?.role || null;
    };
    
    const user = getUserData();
    
    // If no valid user data, redirect to login
    if (!user) {
        sessionStorage.clear();
        localStorage.clear();
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    
    const userRole = getUserRole(user);
    
    // If no valid role found, clear session and redirect
    if (!userRole) {
        sessionStorage.clear();
        localStorage.clear();
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    
    // Check role-based access
    if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
        return <Navigate to="/unauthorized" replace />;
    }
    
    return <AppLayout>{children}</AppLayout>;
}

export default ProtectedRoute;